import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisBaseGlobalsService } from '../service/base/his-base-globals.service';

@Pipe( {
    name: 'hisAmount',
    standalone: false
} )
export class HisAmountPipe implements PipeTransform {
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);


    private decimalSplitter = ',';
    private thousandSplitter = '.';
    private currencySymbol = '€';
    private locale: string;

    constructor() {
        this.locale = this.hisBaseGlobalsService.getLanguage();
    }

    public transform( value: number, symbol?: string ) {
        // check if locale was set as parameter
        switch ( this.locale ) {
            case 'de':
                break;
            case 'en':
                this.setDecimalSplitter( '.' );
                this.setThousandSplitter( ',' );
                break;
            default:
                break;
        }

        let sign=value<0 ? '-' : '';

        let formatted = parseFloat( '' + Math.round( Math.abs(value) * 100 ) / 100).toFixed( 2 );
        let split: string[] = formatted.split( '.' );

        let formattedAmount = '';
        let index = split[0].length;
        while ( index >= 0 ) {
            if ( index >= 3 ) {
                let separator = ( index - 3 ) > 0 ? this.getThousandSplitter() : '';
                formattedAmount = separator + split[0].substring( ( index - 3 ), index ) + formattedAmount;
            } else {
                formattedAmount = split[0].substring( 0, index ) + formattedAmount;
                index = 0;
            }
            index -= 3;
        }
        formattedAmount = sign + formattedAmount;

        let showSymbol = symbol === 'symbol' ? ' ' + this.getCurrencySymbol() : '';
        formattedAmount = formattedAmount + this.getDecimalSplitter() + split[1] + showSymbol;
        return formattedAmount;
    }

    // setter

    /* set decimal splitter */
    private setDecimalSplitter( decimalSplitter: string ): void {
        this.decimalSplitter = decimalSplitter;
    }

    /* set thousand splitter */
    private setThousandSplitter( thousandSplitter: string ): void {
        this.thousandSplitter = thousandSplitter;
    }

    /* set currency symbol */
    private setCurrencySymbol( currencySymbol: string ): void {
        this.currencySymbol = currencySymbol;
    }

    // getter

    /* get configured decimal splitter */
    private getDecimalSplitter(): string {
        return this.decimalSplitter;
    }

    /* get configured thousand splitter */
    private getThousandSplitter(): string {
        return this.thousandSplitter;
    }

    /* get configured currency symbol */
    private getCurrencySymbol(): string {
        return this.currencySymbol;
    }
}
